export default {"src":"/_next/static/media/prep.b2603c83.svg","height":543,"width":984};